// extracted by mini-css-extract-plugin
export default {"explorer":"GraphQLExplorerPage_explorer__4Xex2"};